import classNames from 'classnames'

import { css } from '@portal/styled-system/css'
import type { SystemStyleObject } from '@portal/styled-system/types'

import { useI18n } from '@/shared/lib/i18n'

export function YahooButton(props: { onClick: () => void; styles?: SystemStyleObject }) {
    const { i18n } = useI18n()

    return (
        <button
            className={css(
                {
                    padding: '0',
                    border: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    width: 'full',
                    height: '[40px]',
                    color: 'white',
                    backgroundColor: 'yahoo',
                    borderRadius: 'small',
                    fontFamily: 'montserrat',
                    _hover: { backgroundColor: 'yahoo.hover' },
                    _active: { backgroundColor: 'yahoo.active' },
                    _focusVisible: {
                        boxShadow: '[0 0 0 0.25rem var(--shadow-color)]',
                        boxShadowColor: 'yahoo/25',
                    },
                },
                props.styles
            )}
            onClick={props.onClick}
        >
            <i className={classNames('fa-brands fa-yahoo', css({ fontSize: '2xl', paddingLeft: '[15px]' }))} />
            <div className={css({ margin: 'auto', fontSize: '[13px]', fontWeight: 'medium', paddingRight: '2' })}>
                {i18n.PORTAL_BTN_LOGIN_yahoo}
            </div>
        </button>
    )
}
